"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntityCounts = void 0;
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var use_entities_1 = require("./use-entities");
var use_app_data_1 = require("./use-app-data");
var ENTITY_COUNTS_QUERY = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query EntityCountsQuery($entityTypes: [String]) {\n    platformActivity(input: { entityTypeNames: $entityTypes } ) {\n      metrics {\n        entityCounts {\n          entityTypeName\n          creates\n        }\n      }\n    }\n  }\n"], ["\n  query EntityCountsQuery($entityTypes: [String]) {\n    platformActivity(input: { entityTypeNames: $entityTypes } ) {\n      metrics {\n        entityCounts {\n          entityTypeName\n          creates\n        }\n      }\n    }\n  }\n"])));
var useEntityCounts = function () {
  var entities = (0, use_entities_1.useEntities)();
  var entityTypes = (0, lodash_1.keys)((0, lodash_1.pickBy)(entities, function (entity) {
    return entity.includeInMetrics;
  }));
  return (0, use_app_data_1.useAppData)({
    query: ENTITY_COUNTS_QUERY,
    queryValueKey: 'platformActivity.metrics.entityCounts',
    valueKey: 'items',
    variables: {
      entityTypes: entityTypes
    },
    defaultValue: []
  });
};
exports.useEntityCounts = useEntityCounts;
var templateObject_1;